import { makeStyles, tokens } from "@fluentui/react-components";
import { Highlight24Regular } from "@fluentui/react-icons";
import * as React from "react";
import QuestionSubmitButton from "./question-submit-button";

export default function QuestionSubmit() {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <Highlight24Regular className={styles.highlight_icon} />
      <div className={styles.text}>Answer each question individually by highlighting the text and clicking the arrow to generate answer</div>
      <QuestionSubmitButton />
    </div>
  );
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "24px",
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: "16px",
  },
  text: {
    fontSize: "14px",
    paddingLeft: "16px",
    paddingRight: "16px",
  },
  highlight_icon: {
    color: tokens.colorPaletteLavenderForeground2,
    minHeight: "24px",
    minWidth: "24px",
  },
});
